import SyMenu from "./sy-menu";

export default SyMenu;